import cloneDeep from 'lodash/cloneDeep';
import { SavedView } from '@/app/modules/saved-views/types';
import { MetricsGridConfig } from '@/app/core';
import {
  SavedViewDeserializer,
  SavedViewDeserializerResponse,
} from '@/app/modules/saved-views/types';

const DEBUG = false;

export const savedViewDeserializer: SavedViewDeserializer<MetricsGridConfig> = (
  config: MetricsGridConfig,
  view: SavedView
) => {
  const newConfig = cloneDeep(config);
  // const titleIndices = new Map<string, number>();
  const titleCounts = new Map<string, number>();

  // First, count occurrences of each columnSelectorTitle in the config
  newConfig.groups.forEach((group) => {
    const title = group.columnSelectorTitle;
    if (title) {
      titleCounts.set(title, (titleCounts.get(title) || 0) + 1);
    }
  });

  newConfig.groups.forEach((group, index) => {
    const title = group.id || group.columnSelectorTitle;
    let serializedTitle = title;

    if (titleCounts.get(title) > 1) {
      // const currentIndex = (titleIndices.get(title) || 0) + 1;
      serializedTitle = `${title}___${index}`;
      // titleIndices.set(title, currentIndex);
    }

    group.visible = view.columns.includes(serializedTitle);
  });

  if (DEBUG) {
    console.log(
      'savedViewDeserializer saved view:\n',
      view,
      'before:\n',
      config.groups,
      'after:\n',
      newConfig.groups
    );
  }

  const response: SavedViewDeserializerResponse<MetricsGridConfig> = {
    config: newConfig,
    sorting: {
      key: view.sort.length > 0 ? view.sort[0].key : null,
      direction: view.sort.length > 0 ? view.sort[0].direction : null,
    },
  };

  return Promise.resolve(response);
};
